import CropperPlace from "./CropperPlace";

export default CropperPlace;
